import React from "react";
import { altColor } from "../../utils/constants";

export default function TPChallengeDoneIcon({ color = altColor }) {
  return (
    <svg
      id="Layer_46"
      data-name="Layer 46"
      xmlns="http://www.w3.org/2000/svg"
      width="488.407"
      height="488.407"
      viewBox="0 0 488.407 488.407"
    >
      <path
        id="Pfad_69"
        data-name="Pfad 69"
        d="M417.146,2H75.261A73.261,73.261,0,0,0,2,75.261V417.146a73.261,73.261,0,0,0,73.261,73.261H417.146a73.261,73.261,0,0,0,73.261-73.261V75.261A73.261,73.261,0,0,0,417.146,2Zm24.42,415.146a24.42,24.42,0,0,1-24.42,24.42H75.261a24.42,24.42,0,0,1-24.42-24.42V75.261a24.42,24.42,0,0,1,24.42-24.42H417.146a24.42,24.42,0,0,1,24.42,24.42Zm-56.9-286.206a24.42,24.42,0,0,1,0,34.433L202.491,359.27a24.775,24.775,0,0,1-35.654,0l-59.586-64.226a24.42,24.42,0,1,1,35.409-33.456l42.98,45.666L349.99,132.4a24.42,24.42,0,0,1,34.677-1.465Z"
        transform="translate(-2 -2)"
        fill={color}
      />
    </svg>
  );
}
